<template>
	<h3>Unknown field, please contact system administrator</h3>
</template>
<script>
import gridFieldMixin from '../../../../mixins/grids/gridFieldMixin';
export default {
	name: 'UnknownField',
	mixins: [gridFieldMixin],
};
</script>
